export class PayuProcessor {
  constructor() {

  }

  wait_widget_load(callback) {
    let widget_loaded = false;
    $("script").each((i, script) => {
      if (script.src.startsWith("https://secure.payu.com/front/widget/js/payu-widget.js"))
      {
        widget_loaded = true;
      }
    });
    if (widget_loaded && typeof PayU !== 'undefined') {
      callback();
    } else {
      setTimeout(() => this.wait_widget_load(callback), 100);
    }
  }

  show_widget(data, status) {
    console.log("Widget: "+status+"--> "+JSON.stringify(data));
    this.clean_payu_scripts();

    let script = document.createElement('script');
    script.src = "https://secure.payu.com/front/widget/js/payu-bootstrap.js";
    script.type = "text/javascript";
    script.id = "payu-bootstrap-script";

    this.rdonateId = data.id;

    $.each(data.widget, (k,v) => {
      script.setAttribute(k,v);
    });
    document.head.appendChild(script);

    this.wait_widget_load(() => {
      if (typeof data.cvv !== 'undefined') {
        PayU.Merchant.openWidgetCvv();
      } else {
        PayU.Merchant.openWidget();
      }
      // PayU widget is manipulating the overflow property but sometimes fails to set it back. Disable this.
      $('body').css('overflow', 'inherit');
      $('html').removeAttr('style');
    });
    setTimeout(() => this.what_if_we_are_blocked, 15000);
  }

  post_form(data, status) {
    console.log("Form: "+status+"--> "+JSON.stringify(data));
    let oldform = document.querySelector('#payu-pay-form');
    if (oldform) {
      oldform.parentElement.removeChild(oldform);
    }

    let form = document.createElement('form');
    form.action = data.form.url;
    form.method = "post";
    form.id = "payu-pay-form";
    this.rdonateId = data.id;
    $.each(data.form.params, (k,v) => {
      if (v !== null) {
        let field = document.createElement('input');
        field.type = 'hidden';
        field.name = k;
        field.value = v;
        form.appendChild(field);
      }
    });
    document.querySelector('#donate-form-container-id').appendChild(form);
    form.submit();
  }

  form_or_widget(data, status) {
    if (typeof data.form !== 'undefined') {
      return this.post_form(data, status);
    } else if (typeof data.widget !== 'undefined') {
      return this.widget(data, status);
    } else {
      console.error("Rdonate js data doesn't contain form nor widget");
    }
  }


  what_if_we_are_blocked() {
    if (typeof PayU == 'undefined') {
      alert("Możliwe, że bloker reklam w przeglądarce blokuje załadowanie okienka PayU i uniemożliwia dokonania wpłaty. Prosimy o wyłączenie blokowania reklam na stronach Akcji Demokracji. Nie wyświetlamy reklam ani nie używamy mechanizmów śledzących innych firm lub organizacji.");
    }
  }


  clean_payu_scripts() {
    console.info("clean payu scripts");
    $("script").each((i, script) => {
      if (script.src.startsWith("https://secure.payu.com/"))
      {
        console.log("clean payu script: "+script.src);
        script.parentElement.removeChild(script);
      }
    });
  }



}
